$(function(){

  $(".graph-band").each(function() {
    var that = $(this);
    var note = that.data("percent");
    var percentage = (note/5)*100;
    that.find("span").css("width",percentage+"%");
  });

  var owl = $('.owl-carousel.tem');
  owl.owlCarousel({
    loop:true,
    nav:true,
    items:1,
  });

  owl.owlCarousel();
  $('.customNextBtn').click(function() {
      owl.trigger('next.owl.carousel');
  })
  $('.customPrevBtn').click(function() {
      owl.trigger('prev.owl.carousel', [300]);
  })

  $(".thumbnails").each(function() {
    var that = $(this);
    var nav = that.parent().find(".arrows");
    that.owlCarousel({
      loop:false,
      nav:true,
      dots:true,
      dotsEach: 4,
      items:1,
      navContainer:nav
    });
  });

  $(".cottage-box .arrows button").on("click",function(e){
    e.preventDefault();
  });

  $(".cottage-box .favBtn").on("click",function(e){
    e.preventDefault();
  });
});
